import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

import HelperText from './HelperText'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  textShrink: {
    transform: 'translate(0, 1.5px) scale(0.75)',
    transformOrigin: 'top left',
  },
  radioRoot: {
    paddingLeft: '9px',
    paddingRight: '9px',
    paddingTop: '4.5px',
    paddingBottom: '4.5px',
  },
}))

const RadioField = ({
  field: {
    name,
    value,
    onChange,
    onBlur
  },
  error,
  touched,
  item,
}) => {
  const classes = useStyles()

  const title = item.title || name

  return (
    <FormControl component="fieldset" className={ classes.root }>
      <FormLabel
        component="legend"
        className={ item.compact ? classes.textShrink : '' }
      >
        { title }
      </FormLabel>
      <RadioGroup
        aria-label={ title }
        name={ name }
        value={ value }
        onChange={ onChange }
        row={ item.row ? true : false }
      >
        {
          (item.options || []).map((option, i) => {
            option = typeof(option) === 'string' ? {
              title: option,
              value: option,
            } : option

            return (
              <FormControlLabel
                key={ i }
                value={ option.value }
                label={ option.title }
                control={<Radio className={ classes.radioRoot } />}
              />
            )
          })
        }
      </RadioGroup>
      <HelperText
        helperText={ item.helperText }
        error={ error }
        touched={ touched }
      />
    </FormControl>
  )
}

export default RadioField